import ENGTStatusIcon from './ENGTStatusIcon';

function ENGTBaseIcon({
	fillColorForText = 'currentColor',
	fillColorForImage = 'currentColor',
	label,
}: {
	fillColorForText: string;
	fillColorForImage: string;
	label: string;
}) {
	return <ENGTStatusIcon fillColorForImage={fillColorForImage} fillColorForText={fillColorForText} label={label} />;
}

export default ENGTBaseIcon;
